/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { ProgressButton } from 'components';

const ConfirmDeleteDialog = ({ onClose, open, content, title, handleDeleteItem, disabled, isLoading }) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">{content}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} variant="contained" color="inherit">
					Cancel
				</Button>
				<ProgressButton
					circleColor="secondary"
					isLoading={isLoading}
					button={
						<Button
							onClick={handleDeleteItem}
							variant="contained"
							color="primary"
							disabled={disabled}
							autoFocus
						>
							Delete
						</Button>
					}
				/>
			</DialogActions>
		</Dialog>
	);
};
export default ConfirmDeleteDialog;
